<div *ngIf="layerStateName==='SCHEMA'" class="icon-wrap">
	<mat-icon svgIcon="icon-layer-state-schema" matTooltip="Schema"></mat-icon>
</div>
<div *ngIf="layerStateName==='TOPOLOGY'" class="icon-wrap">
	<mat-icon svgIcon="icon-topology-ring" matTooltip="Topology"></mat-icon>
</div>
<div *ngIf="layerStateName==='DOMAIN'" class="icon-wrap">
	<mat-icon svgIcon="icon-layer-state-domain" matTooltip="Domain"></mat-icon>
</div>
<div *ngIf="layerStateName==='CONTENT'" class="icon-wrap">
	<mat-icon svgIcon="icon-layer-state-content" matTooltip="Content"></mat-icon>
</div>